<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-2">
        <b-field>
          <form-timepicker :label="$t('resources.begin')" v-model="form.starts_at"></form-timepicker>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field>
          <form-timepicker :label="$t('resources.end')" v-model="form.ends_at"></form-timepicker>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {prepareDateTime} from '@/utils'
  import EmployeeSelect from '@/components/EmployeeSelect'

  export default {
    props: ['reservationData', 'editMode'],
    components: {EmployeeSelect},
    data() {
      return {
        form: this.reservationData,
        isEdit: this.editMode || false,
        errors: []
      }
    },
    methods: {
      validate() {
        this.errors = []
        /*проверки*/
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            starts_at: prepareDateTime(this.form.starts_at),
            ends_at: prepareDateTime(this.form.ends_at)
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    watch: {
      reservationData(data) {
        this.form = data
      }
    }
  }
</script>